<template>
  <div class="weather-tools">
    <span class="desc">Pogoda</span>
    <div class="weather-tools__buttons">
      <button class="btn" v-bind:class="[value==3?'active':'']" v-on:click="setValue(3)">
        <SunIconSvg />
      </button>
      <button class="btn" v-bind:class="[value==2?'active':'']" v-on:click="setValue(2)">
        <SunOverColudsIconSvg />
      </button>
      <button class="btn" v-bind:class="[value==1?'active':'']" v-on:click="setValue(1)">
        <CloudIconSvg />
      </button>
      <button class="btn" v-bind:class="[value==0?'active':'']" v-on:click="setValue(0)">
        <NightIconSvg />
      </button>
    </div>
  </div>
</template>

<script>
import SunIconSvg from "@/assets/icon/sun.svg"
import SunOverColudsIconSvg from "@/assets/icon/sun-over-coluds.svg"
import CloudIconSvg from "@/assets/icon/cloud.svg"
import NightIconSvg from "@/assets/icon/night.svg"

export default {
  name: "WeatherTools",
  data(){
    return {
      value: 3
    }
  },
  props: {
    startValue: Number
  },
  components: {
    SunIconSvg,
    SunOverColudsIconSvg,
    CloudIconSvg,
    NightIconSvg
  },
  mounted(){
    this.value = this.startValue;
  },
  methods: {
    setValue(value){
      this.value = value;
      this.$emit('change-value', value);
    }
  }
}
</script>

<style lang="scss">
#photovoltaics{

  .weather-tools{
    z-index: 10;
    margin-left: -0.2rem;
    margin-right: -0.2rem;
    margin-bottom: -32px;

    grid-column: 1 / 3;
    grid-row: 1;

    &__buttons{
      //width: 100%;
      display: flex;
      justify-content: space-between;
      @include media-breakpoint-up(md) {
        display: block;
      }

      @include media-breakpoint-up(lg) {
        .btn {
          width: 36px;
          height: 36px;
        }
      }
    }

    @include media-breakpoint-up(md) {
      grid-column: 1 / span 2;
      margin-bottom: 0;
    }
    @include media-breakpoint-up(lg) {
      grid-column: 1;
      margin-bottom: -60px;
      margin-left: 0;
      margin-right: 0;
    }
    @include media-breakpoint-up(xl) {
      margin-bottom: -32px;
    }
  }
  .btn{
    display: inline-block;
    border: 1px solid $lightgray;
    border-radius: $border-radius;
    background: none;
    padding: 4px;
    margin-left: 4px;
    margin-right: 4px;
    background: $white;
    max-width: 70px;
    width: 100%;

    &.active{
      background: $greenblue;
      border-color: $greenblue;
      svg path{
        fill: $white;
      }
    }


    @include media-breakpoint-up(md) {
      max-width: 50px;

    }
  }
}
</style>
